/* Gallery thumbs and the pathway tab's current state.
   The panels themselves switch with CSS :target, so a browser
   without this script still opens a pathway. */
(function () {
  document.querySelectorAll("[data-ent-gallery]").forEach(function (gallery) {
    var frame = gallery.querySelector(".ent-gallery__img");
    if (!frame) return;
    gallery.querySelectorAll(".ent-thumb").forEach(function (button) {
      button.addEventListener("click", function () {
        var src = button.getAttribute("data-src");
        if (src) frame.src = src;
        frame.alt = button.getAttribute("data-alt") || "";
        gallery.querySelectorAll(".ent-thumb").forEach(function (other) {
          other.removeAttribute("aria-current");
        });
        button.setAttribute("aria-current", "true");
      });
    });
  });

  document.querySelectorAll("[data-ent-tabs]").forEach(function (nav) {
    var links = nav.querySelectorAll("a");
    function mark() {
      var hash = window.location.hash;
      var hit = false;
      links.forEach(function (link) {
        var on = hash && link.getAttribute("href") === hash;
        if (on) hit = true;
        if (on) link.setAttribute("aria-current", "true");
        else link.removeAttribute("aria-current");
      });
      if (!hit && links[0]) links[0].setAttribute("aria-current", "true");
    }
    mark();
    window.addEventListener("hashchange", mark);
  });
})();
